var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35.000pt",
    height: "90.00pt",
    viewBox: "0 0 390.0000 1.0000",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1000,-0.1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1706 4999 c-188 -26 -387 -88 -571 -179 -344 -171 -612 -436 -784 -777 -128 -253 -185 -498 -185 -788 1 -273 49 -487 165 -733 97 -206 194 -340 363 -502 315 -302 427 -426 557 -615 91 -132 156 -250 368 -668 271 -535 305 -600 316 -604 11 -3 92 152 368 697 282 560 403 729 798 1115 193 188 275 281 353 402 108 167 192 378 233 588 14 70 18 138 18 305 -1 249 -18 368 -84 568 -47 143 -76 208 -146 327 -258 440 -666 731 -1175 841 -96 21 -149 26 -320 29 -113 2 -236 0 -274 -6z m473 -459 c595 -116 1031 -663 1031 -1293 0 -555 -338 -1051 -845 -1240 -148 -55 -245 -71 -435 -70 -161 0 -184 3 -291 30 -227 60 -415 168 -584 338 -161 161 -272 349 -334 567 -38 133 -51 230 -51 386 0 190 26 325 96 499 83 207 201 370 370 512 159 133 304 208 494 257 185 47 358 52 549 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2109 3901 l-244 -241 -3 185 -2 185 -350 0 -350 0 0 -350 0 -350 350 0 349 0 3 156 3 155 238 -238 238 -238 -153 -5 -153 -5 0 -345 0 -345 348 -3 347 -2 -2 347 -3 348 -185 3 -184 2 244 245 245 245 -246 246 -246 246 -244 -241z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 2810 l0 -350 350 0 350 0 0 350 0 350 -350 0 -350 0 0 -350z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialPin);
export default __webpack_public_path__ + "static/media/materialPin.5a2f537fec0c8ab76db8960c80c0f125.svg";
export { ForwardRef as ReactComponent };